import PropTypes from 'prop-types';
import React from 'react';

import {
  packageLabelToClassName,
  formatMonthlyCostInLocaleCurrency,
  formatCostInLocaleCurrency,
  getCoreCostFromSkus,
} from '~pricing/lib/helpers';

import PackageHeader from './PackageHeader';
import { HIGHLIGHTED_PACKAGES } from '~pricing/lib/constants';
import { RibbonTextOverridePropType } from '~pricing/lib/proptypes';

const AnnualPackageHeader = ({ packageName, skuCosts, details, ribbonText: ribbonTextOverride = null }) => {
  const packageClassName = packageLabelToClassName(details);
  const coreSeatCost = getCoreCostFromSkus(skuCosts);
  const formattedMonthlyPrice = formatMonthlyCostInLocaleCurrency(coreSeatCost);
  const formattedAnnualPrice = formatCostInLocaleCurrency(coreSeatCost);

  // If this package is marked as highlighted and the ribbon is not
  // in some way being overridden, show the "BEST VALUE" ribbon
  let ribbonText = ribbonTextOverride;
  const highlighted = HIGHLIGHTED_PACKAGES.indexOf(packageName) > -1;
  if (highlighted && !ribbonText && ribbonText !== false) {
    ribbonText = 'BEST VALUE';
  }

  return (
    <PackageHeader
      packageClassName={packageClassName}
      packageName={packageName}
      packageLabel={details.displayName.toUpperCase()}
      priceValue={formattedMonthlyPrice}
      priceUnit=" / month"
      byline={`Pay ${formattedAnnualPrice} Annually`}
      ribbonText={ribbonText}
    />
  );
};

AnnualPackageHeader.propTypes = {
  packageName: PropTypes.string.isRequired,
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  skuCosts: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
  ribbonText: RibbonTextOverridePropType,
};

AnnualPackageHeader.defaultProps = {
  ribbonText: null,
};

export default AnnualPackageHeader;
